/**
 * com.lianjia.xxx 该Agent为ios端壳劲租登录sdk的userAgent，登录sdk的webview不支持jsbridge
 * 而隐私协议页面会在登录sdk打开，所以需要判断一下
 * @returns {boolean}
 */
export const judgePrivacy = () => {
  let judge = false
  try{
    const userAgentJudge = navigator.userAgent.toLowerCase().indexOf('com.lianjia') > -1
    const routerJudge = document.URL.indexOf('channel_page_v2/privacy') > -1
    judge = userAgentJudge && routerJudge
  }catch (e) {
    console.log(e)
  }
  return judge
}
